import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ResetPasswordForm from '../../containers/ResetPassword/ResetPasswordForm';
import { resetPasswordRequest } from '../../redux/modules/auth/auth-middleware';
import Message from '../../containers/Message/Message';

class ResetPasswordPage extends Component {
  handleResetPassword = (username, language) => {
    this.props.dispatch(resetPasswordRequest(username, language));
  }

  render() {
    return (
      <div className="col">
        <Message />
        <ResetPasswordForm handleResetPassword={this.handleResetPassword} language={this.props.language} />
      </div>
    );
  }
}

ResetPasswordPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  token: state.token,
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(ResetPasswordPage);